import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ConfirmModal } from '@mummssoftware/common-ui';
import { formatLocDateMMDDYY } from '@mummssoftware/utils/formatters';
import { useElectionAddendumPrompt } from './useElectionAddendumPrompt';
import defaults from '../../translations/en.json';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    // Keep the card about as wide as the HOPE prompt
    maxWidth: '22rem',
  },
  date: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 8,
  },
  loadError: {
    color: theme.palette.error.main,
    marginTop: 8,
  },
}));

type ElectionAddendumPromptCardProps = Omit<
  ReturnType<typeof useElectionAddendumPrompt>,
  'open'
>;

/** EA Yes/No in the same ConfirmModal layout as the HOPE milestone prompt. */
export const ElectionAddendumPromptCard = ({
  requiredDateShifted,
  actionsDisabled,
  showLoader,
  loadError,
  onYes,
  onNo,
}: ElectionAddendumPromptCardProps) => {
  const classes = useStyles();
  const [beforeDate, afterDate] = defaults.electionAddendumRequiredBody.split(
    '{date}',
  );

  return (
    <ConfirmModal
      onOKClick={onYes}
      onCancelClick={onNo}
      okText={defaults.yes}
      noText={defaults.no}
      isOkDisabled={actionsDisabled}
      isNoDisabled={actionsDisabled}
      modalText={defaults.electionAddendumRequiredTitle}
      content={
        <div className={classes.content}>
          {typeof requiredDateShifted === 'number' ? (
            <span>
              {beforeDate}
              <span className={classes.date}>
                {formatLocDateMMDDYY(requiredDateShifted)}
              </span>
              {afterDate}
            </span>
          ) : null}
          {showLoader ? (
            <div className={classes.loading} aria-busy="true">
              <CircularProgress size={24} />
            </div>
          ) : null}
          {loadError ? (
            <Typography className={classes.loadError} variant="body2">
              {loadError}
            </Typography>
          ) : null}
        </div>
      }
    />
  );
};

export default ElectionAddendumPromptCard;
